export const zIndex = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
  /** Modal overlays and dialogs */
  modal: 100000,
};

export type ZIndexKeys = keyof typeof zIndex;
